module.exports = "/_next/static/images/3e189f9df426764466a1e48033f0d93e-pregnant-woman@mobile@1x.jpg.webp";